module.exports = __webpack_public_path__ + "static/media/Reassemble.905e3a08.jpeg";